import { Box, Typography } from '@mui/material'
import React from 'react'

function HeroSection({children, img}) {
  return (
    <Box
        sx={{
          width: "100%",
          height: ["20rem", "30rem", "23rem", "23rem", "46rem"],
          display: "flex",
          backgroundImage:
            `linear-gradient(45deg, rgba(0,0,0, 0.75), rgba(0,0,0, 0.75)), url(${img})`,
             backgroundSize:'cover',
          backgroundRepeat:'no-repeat',
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "0rem",
            width: ["95%", "90%"],
          }}
        >
          <Typography
            sx={{
              fontSize: ["1.8rem", "3rem", "3rem", "3rem", "5rem"],
              color: "#fff",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            {children}
          </Typography>
        </Box>
      </Box>
  )
}

export default HeroSection